import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const loopSettings = defineIntegrationSettings({
  fields: { enabled: z.boolean(), submitReturnsThroughLoop: z.boolean() },
  secrets: {
    accessToken: z.string().trim().min(1, "Access token is required"),
  },
  connectOnly: {},
  computed: {},
});
